import * as yup from "yup";

// validation for post form
const POST_SCHEMA = yup.object({
    title: yup
        .string()
        .nullable(true)
        .test(
            "len",
            "Must be less than 65 characters",
            (val) => val && val.length <= 65
        )
        .required("Title is required"),

    titleHtml1: yup
        .string()
        .nullable(true)
        .required("Title HTML 1 is required"),

    titleHtml2: yup
        .string()
        .nullable(true)
        .required("Title HTML 2 is required"),

    categories: yup
        .string()
        .nullable(true)
        .required("Category is required"),

    tags: yup
        .string()
        .nullable(true)
        .required("Tags are required"),

    description: yup
        .string()
        .nullable(true)
        .test(
            "len",
            "Must be less than 160 characters",
            (val) => val && val.length <= 160
        )
        .required("Description is required"),

    url: yup
        .string()
        .nullable(true)
        .test("cant-have-spaces", "URL can't have spaces", (val) =>
            val && !val.includes(" ")
        )
        .required("URL is required"),

    horizontalThumbnail: yup.object().nullable(true).required("Required"),

    verticalThumbnail: yup.object().nullable(true).required("Required"),

    faqs: yup
        .array()
        .min(0)
        .of(
            yup.object().shape({
                q: yup.string().nullable(true).test(
                    "len",
                    "Must be less than 65 characters",
                    (val) => val && val.length <= 65
                ).required("Question is required"),
                a: yup.string().nullable(true).test(
                    "len",
                    "Must be less than 160 characters",
                    (val) => val && val.length <= 160
                ).required("Answer is required"),
            })
        ),
});

export const validatePost = (post) => {
    try {
        return {
            status: true, data: POST_SCHEMA.validateSync(post, {
                abortEarly: false,
            })
        };
    } catch (err) {
        let errors = {};
        err.inner.forEach((e) => {
            errors[e.path] = e.message;
        });
        return { status: false, data: errors };
    }

}